import React, { createContext, useContext, useState, useMemo } from 'react';

const AccordionRootContext = createContext(null);
function useAccordionRoot() {
    const context = useContext(AccordionRootContext);
    if (!context) {
        throw new Error('useAccordionRoot must be used within AccordionRootProvider');
    }
    return context;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function AccordionRootProvider({ children }) {
    const [openedAccordion, setOpenedAccordion] = useState('');
    function handleOpenedAccordion(value) {
        setOpenedAccordion(value);
        if (openedAccordion === value) {
            setOpenedAccordion('');
        }
    }
    const value = useMemo(() => ({
        openedAccordion,
        setOpenedAccordion: handleOpenedAccordion,
    }), [openedAccordion]);
    return (React.createElement(AccordionRootContext.Provider, { value: value }, children));
}

export { AccordionRootProvider, useAccordionRoot };
